import { render, staticRenderFns } from "./ScoreClassTable.vue?vue&type=template&id=27059b6c&scoped=true&"
import script from "./ScoreClassTable.vue?vue&type=script&lang=ts&"
export * from "./ScoreClassTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27059b6c",
  null
  
)

export default component.exports